exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-betslip[data-v-4a9e8fd2]{text-align:center;padding:20px;background:var(--white)}.load-betslip__sharing-code[data-v-4a9e8fd2]{display:flex;flex-direction:column;width:100%}.load-betslip__sharing-code__input[data-v-4a9e8fd2]{text-align:center;margin-bottom:10px}.load-betslip__desc[data-v-4a9e8fd2]{margin:0;margin-bottom:10px;font-size:var(--font-normal)}.error[data-v-4a9e8fd2]{display:block;margin-bottom:10px;color:#c00;font-size:var(--font-small);width:100%}", ""]);

// exports
